import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69992412"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block font-bold text-lg tracking-wide" }, "Invite account member", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block text-lg pt-3 w-5/6 tracking-wide" }, " Add members to your team and do more with Axelerate together! Teams make it easier to divide responsibilities and keep everything under one roof. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-200" })
], -1))
const _hoisted_5 = { class: "flex flex-row items-center" }
const _hoisted_6 = { class: "w-3/4 pt-3" }
const _hoisted_7 = { class: "pt-3 pl-3" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col w-full pt-3"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Roles:", -1))
const _hoisted_10 = { class: "flex flex-row w-full space-x-3 py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailChips = _resolveComponent("EmailChips")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CheckBoxGroup = _resolveComponent("CheckBoxGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_EmailChips, {
          chips: _ctx.emails,
          placeholder: "Email"
        }, null, 8, ["chips"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Button, {
          disabled: _ctx.emails.length === 0,
          onOnClick: _ctx.handleSubmit,
          label: "Send invite",
          labelSize: "text-lg",
          variant: "contained"
        }, null, 8, ["disabled", "onOnClick"])
      ])
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (item, index) => {
              return (_openBlock(), _createBlock(_component_CheckBoxGroup, {
                key: `item-checkbox-${index + 1}`,
                fieldId: item.label,
                names: _ctx.checkValues,
                "onUpdate:names": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkValues) = $event)),
                label: item.label,
                value: item.value
              }, null, 8, ["fieldId", "names", "label", "value"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}